var React = require('react');

function Scissors (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"6","cy":"6","r":"3","key":0}),React.createElement("circle",{"cx":"6","cy":"18","r":"3","key":1}),React.createElement("line",{"x1":"20","y1":"4","x2":"8.12","y2":"15.88","key":2}),React.createElement("line",{"x1":"14.47","y1":"14.48","x2":"20","y2":"20","key":3}),React.createElement("line",{"x1":"8.12","y1":"8.12","x2":"12","y2":"12","key":4})]);
}

Scissors.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-scissors"};

module.exports = Scissors;

Scissors.default = Scissors;
